import { Injectable } from '@angular/core';

import { userGroup, leaveLabel } from './../../constants/constants';

import { Observable } from 'rxjs/Observable';
import { ToastController } from 'ionic-angular/components/toast/toast-controller';

import { FirebaseServiceProvider } from './../firebase-service/firebase-service';
import { EndpointServiceProvider } from './../endpoint-service/endpoint-service';

import { User } from './../../model/User';
import { Configuration } from './../../model/Configuration';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Messages } from '../../constants/messages';
import { AlertController } from 'ionic-angular';

@Injectable()
export class CoreProvider {

    private currentUser: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    private currentUserKey: string;
    private currentUserEndpoint: string;
    private currentUserData: any;

    private searched: any = null;
    private toastOffline: any;

    private device: [number, number];

    initialized = false;
    list_users: User[] = [];
    private actualDate: Date = new Date();
    private actualWeekNumber: number;

    private currentDate: Date = new Date();
    private currentWeekNumber: number;

    private weekPointerDiffer: number = 0; //puntatore per spostamento da settimana attuale

    private serverConfig: Configuration = new Configuration();

    private noResetOnPush: boolean = false;

    constructor(
        private endpoint: EndpointServiceProvider,
        private firebase: FirebaseServiceProvider,
        private toastCtrl: ToastController,
        private alertCtrl: AlertController
    ) {

        this.actualWeekNumber = this.getWeekNumber(this.actualDate);
        this.currentWeekNumber = this.getWeekNumber(this.currentDate);

        this.serverConfig.number_of_week_visible_in_advance = 4;
        this.serverConfig.number_of_week_visible_in_precedence = 4;

        this.serverConfig.showBadgeFrom = 1;
        this.serverConfig.type_leave = leaveLabel;

        this.serverConfig.label_privacy = 'PRIVACY';
        this.serverConfig.url_privacy = 'http://';
    }

    get userKey() {
        return this.currentUserKey;
    }

    get userData() {
        return this.currentUserData;
    }

    get actualWeek() {
        return this.actualWeekNumber;
    }

    get actualTimeDate() {
        return this.actualDate;
    }

    get configuration() {
        return this.serverConfig;
    }

    setDevice(height: number, width: number) {
        this.device = [height, width];
    }

    getDevice(): [number, number] {
        return this.device;
    }

    /**
     * Restituisce la data visualizzata dal service
     */
    getCurrentDate() {
        return this.currentDate;
    }

    getListUsers(): User[] {
        return this.firebase.getListUsers();
    }

    /**
     * Show Toast
     */
    showToast(message: string, position: string) {
        let toast = this.toastCtrl.create({
            message: message,
            duration: 3000,
            position: position
        });

        toast.present();
    }

    /**
     * Show Permanent Toast
     */
    showPermanentToast(message: string, position: string) {
        this.toastOffline = this.toastCtrl.create({
            message: message,
            showCloseButton: true,
            closeButtonText: 'OK',
            position: position
        });

        if (this.toastOffline) {
            this.toastOffline.dismiss();
        }
        //  toast.onDidDismiss(callback);
        this.toastOffline.present();
    }

    dismissPermanentToast() {
        if (this.toastOffline) {
            this.toastOffline.dismiss();
        }
    }

    /**
     * Alert login error
     */

    showAlert(text: string, callback: any) {
        let alert = this.alertCtrl.create({
            title: "<b>" + text + "</b>",
            cssClass: 'alert-week',
            buttons: [
                {
                    text: 'Logout',
                    role: 'Logout'
                },
            ]
        });
        alert.present()

        alert.onDidDismiss(callback);
    }

    /**
     * Inizializza app
     * verifica rete
     * verifica autenticazione su firebase
     * prepara token endpoint
     * verifica stato utente su endpoint
     */
    init(): Observable<boolean> {
        //Inizializza il service

        return new Observable(resolve => {

            this.firebase.auth().subscribe(auth => {
                if (auth) { //sia autenticato che con token

                    this.endpoint.setToken(this.firebase.getToken());

                    let token = 'WEB';

                    this.getServerConfig().then(config => {
                        this.serverConfig = config;

                        Messages.hr_confirm = this.serverConfig.msg_confirm_week;

                        this.endpoint.login(token).subscribe(result => {

                            if (result.user_exists) {

                                if (!result.can_login) {

                                    this.showAlert(result.login_message, function () {
                                        //logout
                                        resolve.next(false);
                                    });

                                } else {
                                    this.afterLogin(result);
                                    // this.showToast('Login! Loading Data', 'top');
                                    resolve.next(true);
                                }

                            } else {

                                this.showAlert(result.login_message, function () {
                                    resolve.next(false);
                                });
                            }
                        }, err => {
                            /* if (err.status == 500) {
                                 let result = {
                                     "personal_endpoint": "users/manager/siromarcat@gmailcom",
                                     "user_exists": true,
                                     "language": "IT",
                                     "profile_enabled": true,
                                     "role": "manager"
                                 }
     
                                 this.afterLogin(result);
                                 resolve.next(true);
                             }*/
                        });
                        //leaveLabel;
                    }).catch(err => {
                        //console.log(err);
                    });; //configuration agganciare promise per resto del codice                    

                } else {
                    //this.showAlert('Login failed! Unauthorized!', function () {
                    resolve.next(false);
                    //});
                }
            });

        });
    }

    /**
     * Funziona che carica il provider google per l'accesso
     * ritorna la Promise per la registrazione con google
     */
    login(): Promise<any> {
        let provider = this.firebase.getProviderGoogle();
        provider.setCustomParameters({ prompt: 'select_account' });
        let authService = this.firebase.getAuthService();
        return authService.auth.signInWithRedirect(provider);
    }

    /**
     * Funzioni da eseguire al termine del login
     */
    afterLogin(userOB): void {

        this.currentUserEndpoint = userOB.personal_endpoint;
        this.firebase.getUser(userOB.personal_endpoint).then(userdata => {

            this.initialized = true;

            if (this.serverConfig.canSeeAllLeaveDetails && this.serverConfig.canSeeAllLeaveDetails.indexOf(userdata.payload.val().role) > -1) {
                //console.log('no filter');
                this.afterLeaveFilter(userdata);
            }
            else {

                this.firebase.getLeaveDetailList(userdata.key).then(details => {
                    let list_leaveDetails = [];
                    if (details) {
                        for (let detail of details) {
                            list_leaveDetails.push(detail);
                        }

                        this.afterLeaveFilter(userdata, list_leaveDetails);
                    } else {

                        userdata.leave_detail = [];
                        this.afterLeaveFilter(userdata, list_leaveDetails);
                    }
                }).catch(err => {
                   //console.log(err);
                });
            }

        }).catch(err => {
            //console.log(err);
        });

    }

    afterLeaveFilter(userdata: any, leaveDetails?: any): void {

        if (userdata.payload.val().role == 'am' || userdata.payload.val().role == 'manager' || userdata.payload.val().role == 'am_manager') {

            let userTemp = userdata.payload.val();
            userTemp.key = userdata.key;
            if (leaveDetails)
                userTemp.leave_detail = leaveDetails;

            this.currentUser.next(userTemp);

            this.currentUserKey = userdata.key;
            this.currentUserData = userTemp;

            //in costants definito livelli
            let filterUser = userGroup[userTemp.role];

            this.firebase.getUsers(filterUser).then(users => {
                //this.file.getUsersImages(users);

                users.sort((a: any, b: any) => {
                    if (a.name < b.name) {
                        return -1;
                    } else if (a.name > b.name) {
                        return 1;
                    } else {
                        return 0;
                    }
                });

                //hr nessuna modifica

                let userMod = {};
                let otherUsers = [];

                for (let user of users) {
                    if (user.key == userTemp.key) {
                        userMod = user;
                    }
                    else {
                        otherUsers.push(user);
                    }
                }

                let tempArray = [];
                tempArray.push(userMod);

                let filterUsers = tempArray.concat(otherUsers);

                //console.log(users);
                this.firebase.setListUsers(filterUsers);
                this.list_users = this.firebase.getListUsers();

                this.resetWeekPointer();
            }).catch(err => {
                //console.log(err);
            });

        } else if (userdata.payload.val().role == 'delegate') {
            this.firebase.getDelegations(userdata.key).then(delegations => {

                let delegationsArray = [];
                if (delegations && delegations.length > 0) {
                    for (let delegate of delegations) {
                        delegationsArray.push(delegate.payload.val());
                    }
                }

                let userTemp = userdata.payload.val();
                userTemp.key = userdata.key;
                userTemp.delegations = delegationsArray;

                if (leaveDetails)
                    userTemp.leave_detail = leaveDetails;

                this.currentUser.next(userTemp);

                this.currentUserKey = userdata.key;
                this.currentUserData = userTemp;

                //in costants definito livelli
                let filterUser = userGroup[userTemp.role];

                this.firebase.getUsers(filterUser).then(users => {
                    //this.file.getUsersImages(users);

                    let filteredUsers = [];
                    let delegationUsers = [];

                    for (let user of users) {
                        if (delegationsArray.indexOf(user.key) > -1) {
                            delegationUsers.push(user);
                        }
                        else {
                            if (user.role != 'ad')
                                //if ad dont push se non delegate
                                filteredUsers.push(user);
                        }
                    }

                    delegationUsers.sort((a: any, b: any) => {
                        if (a.name < b.name) {
                            return -1;
                        } else if (a.name > b.name) {
                            return 1;
                        } else {
                            return 0;
                        }
                    });

                    filteredUsers.sort((a: any, b: any) => {
                        if (a.name < b.name) {
                            return -1;
                        } else if (a.name > b.name) {
                            return 1;
                        } else {
                            return 0;
                        }
                    });

                    users = delegationUsers.concat(filteredUsers);

                    this.firebase.setListUsers(users);
                    this.list_users = this.firebase.getListUsers();

                    this.resetWeekPointer();
                }).catch(err => {
                    //console.log(err);
                });
            });

        } else { //AD, HR

            let userTemp = userdata.payload.val();
            userTemp.key = userdata.key;

            if (leaveDetails)
                userTemp.leave_detail = leaveDetails;

            this.currentUser.next(userTemp);

            this.currentUserKey = userdata.key;
            this.currentUserData = userTemp;

            //in costants definito livelli
            let filterUser = userGroup[userTemp.role];

            this.firebase.getUsers(filterUser).then(users => {
                //this.file.getUsersImages(users);

                users.sort((a: any, b: any) => {
                    if (a.name < b.name) {
                        return -1;
                    } else if (a.name > b.name) {
                        return 1;
                    } else {
                        return 0;
                    }
                });

                this.firebase.setListUsers(users);
                //hr nessuna modifica
                //ad inserimento in testa
                if (userTemp.role == 'ad') {

                    let userAD = {};
                    let otherUsers = [];

                    for (let user of users) {
                        if (user.key == userTemp.key) {
                            userAD = user;
                        }
                        else {
                            otherUsers.push(user);
                        }
                    }

                    let tempArray = []
                    tempArray.push(userAD);

                    let filterUsers = tempArray.concat(otherUsers);
                    //console.log(filterUsers);

                    this.firebase.setListUsers(filterUsers);
                }

                //hr primo sulla sua lista 
                if (userTemp.role == 'hr') {
                    let userMod = {};
                    let otherUsers = [];

                    for (let user of users) {
                        if (user.key == userTemp.key) {
                            userMod = user;
                        }
                        else {
                            otherUsers.push(user);
                        }
                    }

                    let tempArray = []
                    if (userMod['name']) {
                        tempArray.push(userMod);
                    }

                    let filterUsers = tempArray.concat(otherUsers);
                    //console.log(filterUsers);

                    this.firebase.setListUsers(filterUsers);
                }

                //defnire screen utenti in caso di segretaria
                //console.log(users);
                this.list_users = this.firebase.getListUsers();

                this.resetWeekPointer();

            }).catch(err => {
                //console.log(err);
            });
        }
    }

    /**.
     * 
     */
    checkAuth(): Observable<boolean> {
        return this.firebase.auth();
    }

    /**
     * Funzione per il logout da firebase (eseuito dal menu)
     */
    logout(): Promise<any> {
        let authService = this.firebase.getAuthService();

        this.firebase.disconnectWeek();

        return authService.auth.signOut();
    }

    /**
     * Carica dati utente connesso globale
     */
    getUserData(): BehaviorSubject<any> {
        return this.currentUser;
    }

    /**
     * Carica dati utente connesso globale
     */
    getUsersList(): User[] {
        return this.list_users;
    }

    /**
     * Restituisce token firebase
     */
    getToken(): string {
        return this.firebase.getToken();
    }

    /**
     * Set searched data
     */
    setSearchedData(searched: any) {
        this.searched = {};
        this.searched = searched;
    }

    /**
     * Get searched data
     */
    getSearchedData(): any {
        return this.searched;
    }

    /**
     * Autocompletamento ricerca weekly gnerico
     */
    getAutocompleteSearchGeneric(query: string, filter: boolean = false): Observable<any> {
        this.endpoint.setToken(this.firebase.getToken());

        //date dipende se weekly o filter view
        let dateFilter = 'y' + this.currentDate.getFullYear() + '/w' + this.currentWeekNumber;

        if (filter) {
            let hour = this.currentDate.getHours();
            let index = 'am';

            if (hour > 11 && hour < 24) {
                index = 'pm';
            }

            let dayOfWeek = this.currentDate.getDay();
            dateFilter = dateFilter + '/' + (dayOfWeek > 0 ? dayOfWeek : 7) + '/' + index;
        }

        return this.endpoint.search_generic(query, dateFilter);
    }

    /**
     * Autocompletamento ricerca weekly
     */
    getAutocompleteSearchValues(query: string, filter: boolean = false): Observable<any> {
        this.endpoint.setToken(this.firebase.getToken());

        //date dipende se weekly o filter view
        let dateFilter = 'y' + this.currentDate.getFullYear() + '/w' + this.currentWeekNumber;

        if (filter) {
            let hour = this.currentDate.getHours();
            let index = 'am';

            if (hour > 11 && hour < 24) {
                index = 'pm';
            }

            let dayOfWeek = this.currentDate.getDay();
            dateFilter = dateFilter + '/' + (dayOfWeek > 0 ? dayOfWeek : 7) + '/' + index;
        }

        return this.endpoint.search_autocomplete(query, dateFilter);
    }

    /**
     * Autocompletamento ricerca weekly
     */
    getAutocompleteSearchValuesFilter(query: string): Observable<any> {
        this.endpoint.setToken(this.firebase.getToken());

        //date dipende se weekly o filter view
        let dateFilter = 'y' + this.currentDate.getFullYear() + '/w' + this.currentWeekNumber;

        let hour = this.currentDate.getHours();
        let index = 'am';

        if (hour > 11 && hour < 24) {
            index = 'pm';
        }

        let dayOfWeek = this.currentDate.getDay();
        dateFilter = dateFilter + '/' + (dayOfWeek > 0 ? dayOfWeek : 7) + '/' + index;


        return this.endpoint.search_autocomplete(query, dateFilter);
    }

    /**
     * Autocompletamento modal edit
     */
    getAutocompletePlacesStore(query: string, language?: string): Observable<any> {
        this.endpoint.setToken(this.firebase.getToken());

        if (!language) {
            language = this.currentUserData.language;
        }

        return this.endpoint.autocompletion_loc(query, language);
    }

    /**
     * Riposiziona la settimana e la data al momento attuale
     */
    resetWeekPointer(force: boolean = false) {

        if (force)
            this.noResetOnPush = false;

        if (this.noResetOnPush)
            return;

        this.currentDate = new Date(this.actualDate);
        this.currentWeekNumber = this.getWeekNumber(this.currentDate);

        this.firebase.setOfflineWeeksBinding(this.getEndpointWeek());

        this.weekPointerDiffer = 0;

        this.setWeeksBinding();//settimana attuale
    }

    /**
     * Controlla settimana precedente
     */
    checkConfirmPreviousWeek(userkey: string): Observable<boolean> {
        return this.firebase.getPreviousWeekConfirmed(this.getPrevEndpointWeek(1) + userkey + '/' + 'confirmed');
    }

    /**
     * Controlla settimana corrente
     */
    checkConfirmWeek(userkey: string): Observable<boolean> {
        return this.firebase.getPreviousWeekConfirmed(this.getEndpointWeek() + userkey + '/' + 'confirmed');
    }

    /**
     * Riposiziona la settimana e la data al momento attuale
     */
    repointerWeek(date: Date) {

        let rangeFrom = this.getDateRangeOfWeek(this.getWeekNumber(this.actualDate));

        this.currentDate = new Date(date);
        this.currentWeekNumber = this.getWeekNumber(this.currentDate);

        this.firebase.setOfflineWeeksBinding(this.getEndpointWeek());

        let rangeTo = this.getDateRangeOfWeek(this.currentWeekNumber);

        var timeDiff = Math.abs(rangeFrom[0].getTime() - rangeTo[0].getTime());
        //console.log(timeDiff);
        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        //console.log(diffDays);

        this.weekPointerDiffer = Math.trunc(diffDays / 7);
        if (rangeFrom[0].getTime() > rangeTo[0].getTime())
            this.weekPointerDiffer = 0 - this.weekPointerDiffer;

        //console.log(this.weekPointerDiffer);

        this.setWeeksBinding();

        for (let i = 1; i <= this.serverConfig.number_of_week_visible_in_advance; i++) {
            this.firebase.setOfflineWeeksBinding(this.getNextEndpointWeek(i));
        }

        for (let i = 1; i <= this.serverConfig.number_of_week_visible_in_advance; i++) {
            this.firebase.setOfflineWeeksBinding(this.getPrevEndpointWeek(i));
        }
    }

    /**
     * Riposiziona la settimana e la data al momento attuale
     */
    getActualWeek() {

        this.currentDate = new Date(this.actualDate);
        this.currentWeekNumber = this.getWeekNumber(this.currentDate);

        this.firebase.setOfflineWeeksBinding(this.getEndpointWeek());

        this.weekPointerDiffer = 0;

        this.setWeeksBinding();//settimana attuale
    }

    /**
    * Riposiziona la settimana e la data al momento attuale
    */
    getActualWeekUser(userkey: string) {

        this.currentDate = new Date(this.actualDate);
        this.currentWeekNumber = this.getWeekNumber(this.currentDate);

        this.firebase.setOfflineWeeksBinding(this.getEndpointWeek());

        this.weekPointerDiffer = 0;

        this.firebase.getWeekBinding(this.getEndpointWeek(), userkey);
    }

    /**
     * Controlla se la prossima mezza giornata è accessibile
     */
    getofflineNextHalfDay(): Promise<boolean> {
        let nextDate = new Date(this.currentDate);
        nextDate.setHours(this.currentDate.getHours() + (12));

        let lastWeekNumber = this.currentWeekNumber;
        let newWeekNumber = this.getWeekNumber(nextDate);

        if (lastWeekNumber == newWeekNumber) {
            return new Promise(resolve => {
                resolve(true);
            });
        } else {
            return this.getofflineNextBlock();
        }
    }

    /**
     * Controlla se la mezza giornata precedente è accessibile
     */
    getofflinePrevHalfDay(): Promise<boolean> {
        let prevDate = new Date(this.currentDate);
        prevDate.setHours(this.currentDate.getHours() - (12));

        let lastWeekNumber = this.currentWeekNumber;
        let newWeekNumber = this.getWeekNumber(prevDate);

        if (lastWeekNumber == newWeekNumber) {
            return new Promise(resolve => {
                resolve(true);
            });
        } else {
            return this.getofflinePrevBlock();
        }
    }

    /**
     * Controlla se la prossima settimana è accessibile
     */
    getofflineNextBlock(): Promise<boolean> {
        if (this.weekPointerDiffer >= this.serverConfig.number_of_week_visible_in_advance) {
            return new Promise(resolve => {
                resolve(false);
            });
        } else {
            return this.firebase.getWeekExist(this.getNextEndpointWeek(1));
        }
    }

    /**
     * Controlla se la settimana precedente è accessibile
     */
    getofflinePrevBlock(): Promise<boolean> {
        if (this.weekPointerDiffer <= - this.serverConfig.number_of_week_visible_in_precedence) {
            return new Promise(resolve => {
                resolve(false);
            });
        } else {
            return this.firebase.getWeekExist(this.getPrevEndpointWeek(1));
        }
    }

    /**
     * Restituisce la mezza giornata attuale
     * @param time Data per ottenere l'indice es. 1_am,3_pm
     * @returns [index, (Morning/Afternoon)]
     */
    getHalfDayIndex(time?: Date): [string, string] {
        //let min = 1;
        let MAX = 7;
        let am = '_am';
        let pm = '_pm';

        let am_text = "Morning";
        let pm_text = "Afternoon";

        let calcTimeFrom = this.currentDate;
        if (time)
            calcTimeFrom = time;

        let dayOfWeek = calcTimeFrom.getDay();
        if (dayOfWeek == 0)
            dayOfWeek = MAX;
        let hour = calcTimeFrom.getHours();

        if (hour > 11 && hour < 24) {
            return [dayOfWeek + pm, pm_text];
        } else {
            return [dayOfWeek + am, am_text];
        }
    }

    /**
     * Aggancia la settimana attuale da firebase
     */
    setWeeksBinding(): void {
        //console.log('Week: ' + this.getEndpointWeek());
        if (this.serverConfig.canSeeAllLeaveDetails && this.serverConfig.canSeeAllLeaveDetails.indexOf(this.currentUserData.role) > -1) {

            this.firebase.getWeeksBinding(this.getEndpointWeek());
        } else {

            //console.log(this.userData.leave_detail);

            this.firebase.getWeeksBinding(this.getEndpointWeek(), this.userData.leave_detail, this.getLeaveLabel());
        }
    }

    /**
     * Restituisce le settimane da firebase
     */
    getWeek(): Observable<any> {

        return this.firebase.getWeeks();
    }

    /**
     * Restituisce la settimana dell'utente passato come chiave
     */
    getWeekUser(userkey: string, resetDate?: boolean): Observable<any> {

        if (resetDate) {
            this.currentDate = new Date(this.actualDate);
            this.currentWeekNumber = this.getWeekNumber(this.currentDate);

            this.weekPointerDiffer = 0;
        }

        this.firebase.getWeekBinding(this.getEndpointWeek(), userkey); //settimana attuale

        return this.firebase.getWeek(userkey);
    }

    /**
     * Restituisce il range tra n settimane successive
     * @param number_of_week 
     */
    getNextWeekNumber(number_of_week: number): Date {
        let tempDate = new Date(this.actualDate);
        tempDate.setDate(this.getActualWeekRange()[0].getDate() + (number_of_week * 7));
        let weekNumberTemp = this.getWeekNumber(tempDate);

        return this.getDateRangeOfWeek(weekNumberTemp)[1];
    }

    /**
     * Restituisce la settimana successiva da firebase
     */
    getNextWeek(): void {
        this.currentDate.setDate(this.currentDate.getDate() + (7));
        this.currentWeekNumber = this.getWeekNumber(this.currentDate); //data attuale

        this.weekPointerDiffer = this.weekPointerDiffer + 1;

        this.setWeeksBinding();
    }

    /**
     * Restituisce il range tra n settimane successive
     * @param number_of_week 
     */
    getPrevWeekNumber(number_of_week: number): Date {
        let tempDate = new Date(this.actualDate);
        tempDate.setDate(this.getActualWeekRange()[0].getDate() - (number_of_week * 7));
        let weekNumberTemp = this.getWeekNumber(tempDate);

        return this.getDateRangeOfWeek(weekNumberTemp)[0];
    }

    /**
     * Restituisce la settimana precedente da firebase
     */
    getPrevWeek(): void {
        this.currentDate.setDate(this.currentDate.getDate() - (7));
        this.currentWeekNumber = this.getWeekNumber(this.currentDate); //data attuale

        this.weekPointerDiffer = this.weekPointerDiffer - 1;

        this.setWeeksBinding();
    }

    /**
     * Restituisce la mezza giornata successiva
     */
    getNextHalfDay(): boolean {
        this.currentDate.setHours(this.currentDate.getHours() + (12));

        let lastWeekNumber = this.currentWeekNumber;
        this.currentWeekNumber = this.getWeekNumber(this.currentDate); //data attuale

        if (this.currentWeekNumber == lastWeekNumber) {
            return true;
        } else {

            this.weekPointerDiffer = this.weekPointerDiffer + 1;
            this.setWeeksBinding();
            return false;
        }
    }

    /**
     * Restituisce la mezza giornata precedente
     */
    getPrevHalfDay(): boolean {
        this.currentDate.setHours(this.currentDate.getHours() - (12));
        let lastWeekNumber = this.currentWeekNumber;
        this.currentWeekNumber = this.getWeekNumber(this.currentDate); //data attuale

        if (this.currentWeekNumber == lastWeekNumber) {
            return true;
        } else {

            this.weekPointerDiffer = this.weekPointerDiffer - 1;
            this.setWeeksBinding();
            return false;
        }
    }

    /**
     * Restituisce le settimane da firebase
     */
    getNextWeekUser(userkey: string): void {
        this.currentDate.setDate(this.currentDate.getDate() + (7));
        this.currentWeekNumber = this.getWeekNumber(this.currentDate); //data attuale

        this.weekPointerDiffer = this.weekPointerDiffer + 1;

        this.firebase.getWeekBinding(this.getEndpointWeek(), userkey);
    }

    /**
     * Restituisce le settimane da firebase
     */
    getPrevWeekUser(userkey: string): void {
        this.currentDate.setDate(this.currentDate.getDate() - (7));
        this.currentWeekNumber = this.getWeekNumber(this.currentDate); //data attuale

        this.weekPointerDiffer = this.weekPointerDiffer - 1;

        this.firebase.getWeekBinding(this.getEndpointWeek(), userkey);
    }

    /**
     * Restituisce il numero di settimane di spostamento da quella attuale
     */
    getWeekDiffer(): number {
        return this.weekPointerDiffer;
    }

    /**
     * Week confirmation
     */
    confirmWeek(userkey: string) {
        this.endpoint.setToken(this.firebase.getToken());

        let year = this.currentDate.getFullYear();

        let mod = 'year/y' + year + '/w' + this.currentWeekNumber + '/' + userkey;

        this.endpoint.confirm_week(mod).subscribe(result => {
            //console.log(result);
        });

    }

    /**
     * Unlock week (toggle lock on week)
     */
    unlockWeek(userkey: string) {
        this.endpoint.setToken(this.firebase.getToken());

        let year = this.currentDate.getFullYear();

        let mod = 'year/y' + year + '/w' + this.currentWeekNumber + '/' + userkey;

        this.endpoint.week_lock(mod).subscribe(result => {
            // console.log(result);
        });
    }

    /**
     * Salva modifiche alla settimana
     */
    saveWeek(userkey: string, week: any, places?: any) {
        this.endpoint.setToken(this.firebase.getToken());

        let year = this.currentDate.getFullYear();

        let id_week = 'y' + year + '-w' + this.currentWeekNumber + '-' + userkey;

        this.endpoint.save_slots(id_week, week, places).subscribe(result => {
            //console.log(result);
        });
    }

    /**
     * Carica configurazione dal server
     */
    private getServerConfig(): Promise<any> {
        return this.firebase.getConfiguration();
    }

    /**
     * Restituisce la lista di leave label
     */
    getLeaveLabel(clean?: boolean): string[] {

        let labels = [];
        for (let label of this.serverConfig.type_leave)
            labels.push(label);

        if (!clean)
            labels.push('Leave');

        return labels;
    }

    /**
     * Crea string endpoint settimana
     */
    getEdnpointCustomWeek(week_number: number): string {

        let year = this.actualDate.getFullYear();

        return '/year/y' + year + '/w' + week_number + '/';
    }

    /**
     * Crea string endpoint della settimana attuale
     */
    getEdnpointActualWeek(): string {

        let year = this.actualDate.getFullYear();

        return '/year/y' + year + '/w' + this.actualWeekNumber + '/';
    }

    /**
     * Crea stringa endpoint
     */
    private getEndpointWeek(): string {

        let year = this.currentDate.getFullYear();

        return '/year/y' + year + '/w' + this.currentWeekNumber + '/';
    }

    /**
     * Crea stringa endpoint
     */
    private getNextEndpointWeek(weeks: number): string {

        let date = new Date(this.currentDate);

        date.setDate(this.currentDate.getDate() + (7 * weeks));

        let weeknumber = this.getWeekNumber(date); //data attuale
        let year = date.getFullYear();

        return '/year/y' + year + '/w' + weeknumber + '/';
    }

    /**
     * Crea stringa endpoint
     */
    private getPrevEndpointWeek(weeks: number): string {

        let date = new Date(this.currentDate);

        date.setDate(this.currentDate.getDate() - (7 * weeks));

        let weeknumber = this.getWeekNumber(date); //data attuale
        let year = date.getFullYear();

        return '/year/y' + year + '/w' + weeknumber + '/';
    }

    /**
     * Restituisce le stringe per il weekRange
     */
    getActualWeekRange(): [Date, Date] {
        return this.getDateRangeOfWeek(this.actualWeekNumber);
    }

    /**
     * Restituisce le stringe per il weekRange
     */
    getWeekRange(): [Date, Date] {
        return this.getDateRangeOfWeek(this.currentWeekNumber);
    }

    /*
      Restituisce il numero della settimana corrente
    */
    getWeekNumber(d): number {
        // Copy date so don't modify original
        d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
        // Set to nearest Thursday: current date + 4 - current day number
        // Make Sunday's day number 7
        d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
        // Get first day of year
        let yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
        // Calculate full weeks to nearest Thursday
        var weekNo = Math.ceil((((d - <any>yearStart) / 86400000) + 1) / 7);
        // Return array of year and week number
        return weekNo;
    }

    /*
      Restituisce il range della settimana in parametro
    */
    getDateRangeOfWeek(weekNo: number): [Date, Date] {

        var d1 = new Date();

        let numOfdaysPastSinceLastMonday = d1.getDay() - 1;
        d1.setDate(d1.getDate() - numOfdaysPastSinceLastMonday);

        var weekNoToday = this.getWeekNumber(d1);

        var weeksInTheFuture = weekNo - weekNoToday;
        d1.setDate(d1.getDate() + 7 * weeksInTheFuture);

        //var rangeIsFrom = d1.getDate() + " " + (d1.getMonth() + 1) + " " + d1.getFullYear();
        let from = new Date(d1);
        from.setHours(0);
        d1.setDate(d1.getDate() + 6);

        //var rangeIsTo = d1.getDate() + " " + (d1.getMonth() + 1) + " " + d1.getFullYear();
        let to = new Date(d1);
        to.setHours(0);
        return [from, to];
    };

}


// WEBPACK FOOTER //
// ./src/providers/core-service/core-service.ts